import React, { useContext } from 'react'
import { Route, Switch, Redirect } from 'react-router'
import UserContext from 'shared/components/context/user'

import Home from '../components/supercut/home'
import Detail from '../components/supercut/detail'
import Message from 'shared/components/message/flash-message'
import CapturePushNotification from '../components/supercut/shared/components/capture-push-notification'

const SupercutRoute = () => {
    const { user, isLoggedIn } = useContext(UserContext)

    if (!isLoggedIn) {
        return <Redirect to={'/login?next=/supercut'} />
    }

    const hasAccess = user.isStaff || user.permissions.access_dvr

    if (!hasAccess) {
        return <Redirect to={'/'} />
    }
    return (
        <>
            <Message isDesktop />
            <CapturePushNotification />
            <Switch>
                <Route exact path="/supercut" component={Home} />
                <Route exact path="/supercut/detail/:captureId" component={Detail} />
            </Switch>
        </>
    )
}

export default SupercutRoute
